// @flow

import type { ReduxAction } from './index'

// Action types
export const ADD_SUCCESS_NOTIFICATION: 'nm/SUCCESS_NOTIFICATION_ADD' = 'nm/SUCCESS_NOTIFICATION_ADD'
export const ADD_ERROR_NOTIFICATION: 'nm/ERROR_NOTIFICATION_ADD' = 'nm/ERROR_NOTIFICATION_ADD'
export const RESET_NOTIFICATION: 'nm/NOTIFICATION_RESET' = 'nm/NOTIFICATION_RESET'

type ACTION_ADD_SUCCESS_NOTIFICATION = {| type: typeof ADD_SUCCESS_NOTIFICATION, payload: string |}
type ACTION_ADD_ERROR_NOTIFICATION = {| type: typeof ADD_ERROR_NOTIFICATION, payload: string |}
type ACTION_RESET_NOTIFICATION = {| type: typeof RESET_NOTIFICATION |}

export type NotificationManagerAction =
  | ACTION_ADD_SUCCESS_NOTIFICATION
  | ACTION_ADD_ERROR_NOTIFICATION
  | ACTION_RESET_NOTIFICATION

type NotificationManagerState_ = {|
  type: '' | 'SUCCESS' | 'ERROR',
  message: string,
|}
export type NotificationManagerState = $Shape<NotificationManagerState_>
// Initial state
export const initialState = {
  type: '',
  message: '',
}

// Reducer
export const reducer = (
  state: NotificationManagerState = initialState,
  action: ReduxAction
): NotificationManagerState => {
  switch (action.type) {
    case ADD_SUCCESS_NOTIFICATION:
      return { ...state, type: 'SUCCESS', message: action.payload }
    case ADD_ERROR_NOTIFICATION:
      return { ...state, type: 'ERROR', message: action.payload }
    case RESET_NOTIFICATION:
      return initialState
    default:
      return state
  }
}

// Action creators
export const addSuccessNotification = (message: string): ACTION_ADD_SUCCESS_NOTIFICATION => ({
  type: ADD_SUCCESS_NOTIFICATION,
  payload: message,
})
export const addErrorNotification = (message: string): ACTION_ADD_ERROR_NOTIFICATION => ({
  type: ADD_ERROR_NOTIFICATION,
  payload: message,
})
export const resetNotification = (): ACTION_RESET_NOTIFICATION => ({ type: RESET_NOTIFICATION })

export default reducer



// WEBPACK FOOTER //
// ./src/store/notification-manager.js